import $http from '@/libs/axios'
import FeaturesHelper from '@/utils/features-helper'

class PlansAPIs {
  static async getPackagesList() {
    return (await $http.get('/packages/list')).data
  }

  static async getFeatures(type: any) {
    const featuresType = type ?? 'addon,both' // 'all' | 'addon' | 'package' | 'both'
    const { features } = (await $http.get(`/features/list?type=${featuresType}`)).data
    features.forEach((feature: any, idx: number) => {
      features[idx] = FeaturesHelper.setLocales(feature)
    })
    return features
  }
}

export default PlansAPIs
